import { useCallback, useState } from 'react'

type LocalStorage = Pick<Storage, 'getItem' | 'setItem'>

export const SHOW_INLET_TEMPERATURE_STORAGE_KEY = 'agrid.realtime.showInletTemperature'

const getStorage = (storage?: LocalStorage): LocalStorage | null => {
    if (storage) {
        return storage
    }
    return typeof window === 'undefined' ? null : window.localStorage
}

export const getShowInletTemperaturePreference = (storage?: LocalStorage): boolean => {
    return getStorage(storage)?.getItem(SHOW_INLET_TEMPERATURE_STORAGE_KEY) === 'true'
}

export const setShowInletTemperaturePreference = (value: boolean, storage?: LocalStorage): void => {
    getStorage(storage)?.setItem(SHOW_INLET_TEMPERATURE_STORAGE_KEY, JSON.stringify(value))
}

const useShowInletTemperature = () => {
    const [showInletTemperature, setShowInletTemperatureState] = useState(() => getShowInletTemperaturePreference())

    const setShowInletTemperature = useCallback((value: boolean) => {
        setShowInletTemperatureState(value)
        setShowInletTemperaturePreference(value)
    }, [])

    return [showInletTemperature, setShowInletTemperature] as const
}

export default useShowInletTemperature
